<template>
  <button :disabled="disabled || isButtonLoading" :type="buttonType" :class="className" @click="handleSubmit">
    {{ buttonText }}
    <slot></slot>
  </button>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
defineProps({
  className: { type: String, default: '' },
  buttonText: { type: String, default: '' },
  buttonType: { type: String, default: 'button' },
  handleSubmit: { type: Function, required: true },
  disabled: { type: Boolean, default: false },
});

const isButtonLoading = computed(() => store.getters['common/isButtonLoading']);
</script>
